// Shared helpers + constants for the Settings module (Phase 1).

export const LANGUAGES = [
  { key: "en", label: "English" },
  { key: "hi", label: "हिन्दी (Hindi)" },
  { key: "mr", label: "मराठी (Marathi)" },
  { key: "kn", label: "ಕನ್ನಡ (Kannada)" },
  { key: "ta", label: "தமிழ் (Tamil)" },
  { key: "te", label: "తెలుగు (Telugu)" },
  { key: "gu", label: "ગુજરાતી (Gujarati)" },
  { key: "ml", label: "മലയാളം (Malayalam)" },
];

export const DATE_FORMATS = ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY-MM-DD"];
export const TIME_FORMATS = [
  { key: "12h", label: "12-hour (AM/PM)" },
  { key: "24h", label: "24-hour" },
];
export const WEEK_STARTS = [
  { key: "monday", label: "Monday" },
  { key: "sunday", label: "Sunday" },
];

export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
  "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
  "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan",
  "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh",
  "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands", "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir",
  "Ladakh", "Lakshadweep", "Puducherry",
];

export const GST_RATES = [0, 5, 18];

export function previewNumber(scheme, year) {
  const p = scheme?.prefix || "";
  const len = Math.max(Number(scheme?.length) || 6, 3);
  const seq = Number(scheme?.starting_seq) || 1;
  const body = String(seq).padStart(len, "0");
  return scheme?.include_year ? `${p}-${year}-${body}` : `${p}-${body}`;
}
